import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useAxios } from '../../hooks/useAxios';
import axios from 'axios';
import Alert from 'react-bootstrap/Alert';
import { Console, MLInstance } from '../../services/platform-api';
import { GetUserEmail } from '../../services/get-user-email';
import { useSessionStorage } from '../../hooks/useSessionStorage';
import { WorkflowConfig } from '../workflow-config';
import StatusMessages from '../recipe-status-messages';
import { Preloader } from '../preloader';
import { getSampleFiles, SamepleElements } from '../../data/platform/sample_files_index';
import PongGame from '../../components/pongGame';
import '../../assets/css/pong.scss';

const FinancialReportWorkFlow = ({
  workato_recipe_id,
  combination_id,
  connectors,
  activeTab,
  arc_tab_ref1,
  arc_tab_ref2,
  webhook_url,
  recipeSetupStatus,
  recipeActive,
  refreshTheRecipe,
}) => {
  const { data: defaultJobID = null, fetchNow: starJobDefaultCompare, resetData: resetDefaultJobID } = useAxios();
  const { data: customJobID = null, fetchNow: starJobCustomCompare, resetData: resetCustomJobID } = useAxios();
  const { data: defaultJobResult = null, fetchNow: checkDefaultJob, resetData: resetDefaultJob } = useAxios();
  const { data: customJobResult = null, fetchNow: checkCustomJob, resetData: resetCustomJob } = useAxios();
  const { data: lookupTableData = null, fetchNow: checkWorkatoJobStatus } = useAxios();

  const [workato_id] = useSessionStorage('workatoId', '');
  const [WJST_id] = useSessionStorage('WJST_id', 1);
  const [jobIntervals, setJobIntervals] = useState({});
  const [jobStatusIntervalId, setJobStatusIntervalId] = useState();
  const [defaultComparison, setDefaultComparison] = useState(null);
  const [customComparison, setCustomComparison] = useState(null);
  const [runWorkflow, setRunWorkflow] = useState(false);
  const [selectedFocusArea, setSelectedFocusArea] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [settingUpRecipe, setSettingUpRecipe] = useState(true);

  const handleClose = () => setShowModal(false);
  const [showModal, setShowModal] = useState(false);
  const handleClosePong = () => setShowModalPong(false);
  const [showPong, setShowModalPong] = useState(false);
  const handleClosePongOffer = () => setShowPongOffer(false);
  const [showPongOffer, setShowPongOffer] = useState(false);
  const [showBtnReady, setShowBtnReady] = useState(false);

  const email = GetUserEmail();
  const [userId] = useSessionStorage('userId', '');

  const [resetStatuses, setResetStatuses] = useState(false);
  const [sampleFileName1, setSampleFileName1] = useState(null);
  const [sampleFile1, setSampleFile1] = useState(null);
  const {
    get_config,
    wf_config,
    save_wf_config,
    fetchSetting,
    setFetchSetting,
    configAlertType,
    configAlertContent,
    configChanged,
    setConfigChanged,
    wf_configSet,
  } = WorkflowConfig({
    combination_id: combination_id,
  });

  const headers = {
    'Content-type': 'application/json',
    'x-user-email': 'integrations@arcanum.ai',
    'x-user-token': '62f4f964-1743-4667-88a3-6b2d2506a159',
  };

  // PONG GAMWE AND RESULT CONTROL
  useEffect(() => {
    if (defaultComparison && customComparison) {
      setShowPongOffer(false);
      if (showPong) {
        setShowBtnReady(true);
      } else {
        setShowPongOffer(false);
        setShowModal(true);
      }
    }
  }, [customComparison, defaultComparison]);

  useEffect(() => {
    setSettingUpRecipe(recipeSetupStatus === 'complete' ? false : true);
    if (!sampleFileName1) {
      handleLoadSampleFiles();
    }
  }, [recipeSetupStatus, sampleFileName1]);

  const handleLoadSampleFiles = async () => {
    const files = await getSampleFiles(combination_id);
    if (files !== null && files.length) {
      const [file_item1] = files;
      setSampleFileName1(file_item1.name);
      setSampleFile1(file_item1);
    }
  };

  const handleRunWithSample = async () => {
    const newname = sampleFile1.name.split('/').pop();
    setupFile(sampleFile1, newname);
  };

  const onFileChange = (e) => {
    const _file = e.target.files[0];
    if (check_file(_file)) {
      setupFile(_file, _file.name);
    }
  };

  const setupFile = (_file, filename) => {
    arc_tab_ref1.current.click();
    setSelectedFileName(filename);
    const fileReader = new FileReader();
    fileReader.readAsDataURL(_file);
    fileReader.onload = () => {
      if (fileReader !== null) {
        setSelectedFile(fileReader.result);
      }
    };
  };

  const check_file = (file) => {
    const allowedTypes = ['application/pdf'];

    if (!file) {
      alert('Please select a file');
      return;
    }

    const maxSize = 15 * 1024 * 1024; // 15 megabytes
    if (file && file.size > maxSize) {
      alert('File size too large');
      return;
    }

    if (!allowedTypes.includes(file.type)) {
      alert('File type not supported');
      return;
    }
    return true;
  };

  useEffect(() => {
    // if we are ready to run the workflow and we also have config set then lets run it
    if (runWorkflow && wf_configSet) {
      run_workflow();
    }

    if (configChanged) {
      save_this_config();
      setConfigChanged(false);
    }

    // if job id is set start polling ML for response
    if (defaultJobID) {
      if (defaultJobID.status !== 'error') {
        run_job_check(defaultJobID.jobId?.wf_id, 'default');
      } else {
        setDefaultComparison(defaultJobID?.message);
      }
    }
    if (customJobID) {
      if (customJobID.status !== 'error') {
        run_job_check(customJobID.jobId?.wf_id, 'custom');
      } else {
        setCustomComparison(customJobID?.message);
      }
    }

    if (defaultJobResult && (defaultJobResult.status === 'COMPLETE' || defaultJobResult.status === 'FAILED')) {
      clearInterval(jobIntervals['default']);
      if (defaultJobResult && defaultJobResult.status === 'COMPLETE') {
        setDefaultComparison(defaultJobResult?.report);
      } else {
        setDefaultComparison('Test Failed, check your file');
      }
    }

    if (customJobResult && (customJobResult.status === 'COMPLETE' || customJobResult.status === 'FAILED')) {
      clearInterval(jobIntervals['custom']);
      if (customJobResult && customJobResult.status === 'COMPLETE') {
        setCustomComparison(customJobResult?.report);
      } else {
        setCustomComparison('Test Failed, check your file');
      }

      setFetchSetting('');
    }

    if (wf_config && fetchSetting === 'get_config') {
      setSelectedFocusArea(wf_config.variables.SELECTED_FOCUS_AREA);
      setFetchSetting('');
    }
  }, [
    runWorkflow,
    wf_config,
    defaultJobID,
    customJobID,
    fetchSetting,
    configChanged,
    defaultJobResult,
    customJobResult,
  ]);

  const run_job_check = (the_job_id, whichJob) => {
    // Check if an interval for the given job already exists
    if (jobIntervals[whichJob]) {
      return;
    }

    const intervalId = setInterval(() => {
      // check job loop
      const payload = {
        jobId: {
          wf_id: the_job_id,
        },
      };

      let url = `${MLInstance}/api/financial-analysis/complete/`;
      if (whichJob === 'default') {
        checkDefaultJob(url, 'POST', payload);
      } else if (whichJob === 'custom') {
        checkCustomJob(url, 'POST', payload);
      }
    }, 7000);

    // Update the jobIntervals state with the new intervalId
    setJobIntervals((jobIntervals) => ({
      ...jobIntervals,
      [whichJob]: intervalId,
    }));
  };

  const stopJobStatusPoll = () => {
    clearInterval(jobStatusIntervalId);
  };

  // runs the workato webhook recipe for this flow
  const run_workflow = () => {
    setResetStatuses(true);

    let file_to_upload = '';
    //file_to_upload = selectedFile.replace('data:image/png;base64,', '');
    file_to_upload = selectedFile.replace('data:application/pdf;base64,', '');
    // file_to_upload = file_to_upload.replace('data:text/csv;base64,', '');

    const payload = {
      combination_id: combination_id,
      email: email,
      user_id: userId,
      file_name: selectedFileName,
      file_binary: file_to_upload,
    };

    axios({
      method: 'post',
      url: webhook_url,
      data: payload,
    })
      .then((response) => {
        if (response.status === 200) {
          // force tab change
          arc_tab_ref2.current.click();

          // run the lookup job status function
          if (WJST_id) {
            let this_id = setInterval(() => {
              // check job loop
              checkWorkatoJobStatus(
                `/api/platform/proxy?url=api/managed_users/${workato_id}/lookup_tables/${WJST_id}/rows`,
                'GET',
                null,
                headers,
              );
              setResetStatuses(false);
            }, 5000);
            setJobStatusIntervalId(this_id);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
    setRunWorkflow(false);
  };

  const test_configuration = () => {
    // reset the data8
    resetDefaultJob();
    resetCustomJob();
    resetCustomJobID();
    resetDefaultJobID();
    setDefaultComparison(null);
    setCustomComparison(null);
    setJobIntervals([]);

    setShowBtnReady(false);

    if (wf_configSet) {
      setShowPongOffer(true);

      let file_to_upload = '';
      //  file_to_upload = selectedFile.replace('data:image/png;base64,', '');
      file_to_upload = selectedFile.replace('data:application/pdf;base64,', '');
      // file_to_upload = file_to_upload.replace('data:text/csv;base64,', '');

      const payload = {
        combination_id: combination_id,
        file_name: selectedFileName,
        file_binary: file_to_upload,
        default: false,
      };
      starJobCustomCompare(`/api/platform/financial_analysis/start_comparison`, 'POST', payload, false);
      // run the default config version
      const payload2 = {
        combination_id: combination_id,
        file_name: selectedFileName,
        file_binary: file_to_upload,
        default: true,
      };
      starJobDefaultCompare(`/api/platform/financial_analysis/start_comparison`, 'POST', payload2, false);
    }
  };

  // first we check if we have the config set before we run the workflow recipe
  const run_workflow_check = () => {
    setRunWorkflow(true);
    if (!wf_configSet) {
      Console('do not have the config lets grab it: ', '');
      get_config();
    }
  };

  const save_this_config = () => {
    const payload = {
      variables: {},
    };

    if (selectedFocusArea) {
      payload.variables.SELECTED_FOCUS_AREA = selectedFocusArea;
      setSelectedFocusArea(selectedFocusArea);
    }
    save_wf_config(payload);
  };

  const financialReportFocusArea = [
    { value: '', label: 'Please Select' },
    { value: 'overall-financial-position', label: 'Overall financial position' },
    { value: 'risk-and-vulnerabilities', label: 'Risk and vulnerabilities if any' },
    { value: 'opportunities-and-strengths', label: 'Opportunities and strengths if any' },
    { value: 'cash-flow-management', label: 'Cash flow management' },
    { value: 'sales-and-income', label: 'Sales and income' },
  ];

  const handleFocusAreaChange = (event) => {
    setSelectedFocusArea(event.target.value);
    setConfigChanged(true);
  };

  const hidePongShowResult = () => {
    setShowModal(true);
    setShowModalPong(false);
  };

  const handlePlayPong = () => {
    setShowModalPong(true);
  };

  return (
    <>
      {showPongOffer && (
        <Modal
          show={showPongOffer}
          onHide={handleClosePongOffer}
          backdrop="static"
          size="lg"
          height="700px"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          dialogClassName="custom-modal"
        >
          <Row className="align-items-center d-flex flex-column justify-content-center">
            <Col className="p-5 mh_100 overflow-scroll text-center">
              <h4>
                It can take a few seconds to process your request. Want to have a quick game of pong while you wait?
              </h4>
              <br />
              <Button variant="primary" type="submit" onClick={handlePlayPong} className="px-4">
                Play Pong Game
              </Button>
              <br />
              <br />
              Or you can wait.
              <br />
              <Preloader smallscreen={true} />
              <br />
              <strong>Once the results are ready we will let alert you.</strong>
            </Col>
          </Row>
        </Modal>
      )}

      {showPong && (
        <Modal
          show={showPong}
          onHide={handleClosePong}
          backdrop="static"
          size="lg"
          height="700px"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          dialogClassName="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ width: '100%', lineHeight: '47px' }}>
              {showBtnReady ? (
                <div>
                  Processing Complete &nbsp;
                  <div class="right">
                    <Button variant="primary" type="submit" onClick={hidePongShowResult} className=" px-4">
                      See Results
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  <div class="right">
                    Processing <div className="pulse_loader">.</div>
                  </div>
                  Enjoy some PONG while you wait!
                </>
              )}
            </Modal.Title>
          </Modal.Header>
          <PongGame />
        </Modal>
      )}

      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Compare your configuration to the default</Modal.Title>
        </Modal.Header>
        <Row>
          <Col className="p-5 mh_100 overflow-scroll">
            <h3>Default configuration</h3>
            <br />
            {defaultComparison ? (
              <>
                {defaultComparison && (
                  <p dangerouslySetInnerHTML={{ __html: defaultComparison.replace(/\r?\n/g, '<br>') }} />
                )}
              </>
            ) : (
              <Preloader smallscreen={true} />
            )}
          </Col>
          <Col className="p-5 mh_100 overflow-scroll">
            <h3>Your current configuration</h3>
            <br />
            {customComparison ? (
              <>
                {customComparison && (
                  <p dangerouslySetInnerHTML={{ __html: customComparison.replace(/\r?\n/g, '<br>') }} />
                )}
              </>
            ) : (
              <Preloader smallscreen={true} />
            )}
          </Col>
        </Row>
        <Modal.Footer>
          <Button onClick={handleClose}>Close</Button>
        </Modal.Footer>
      </Modal>

      {connectors.map((connector, key) => {
        return activeTab === 'wf-conn-' + key ? (
          <Col className="basic-form" key={'conn-info' + connector?.id}>
            <>
              {settingUpRecipe ? (
                <>
                  <Preloader smallscreen={true} />
                  <br />
                  <h4 className="text-center">Getting your workflow ready</h4>
                </>
              ) : !recipeActive ? (
                <>
                  <br />
                  <h4 className="text-center">Workflow Stopped</h4>
                  <br />
                  <p className="text-center">Please start your workflow to begin.</p>
                </>
              ) : (
                <>
                  <header>
                    <img
                      src={`/images/${connector?.icon}`}
                      className="icon-solutions float-left"
                      alt={connector?.name}
                    />
                  </header>

                  {connector?.provider === 'manual_upload' ? (
                    <>
                      <h3>Upload your financial document</h3>
                      <p>Ideally your file exported from Xero</p>
                      <input type="file" onChange={onFileChange} value={selectedFile ? selectedFile.name : ''} />
                      <br />
                      <small>Note: pdf file format supported</small>
                      <SamepleElements handleRunWithSample={handleRunWithSample} sampleFileName1={sampleFileName1} />
                    </>
                  ) : connector?.provider === 'xero' && connector?.name.toLowerCase().includes('input') ? (
                    <>
                      <h3>Xero Input</h3>
                      <p></p>
                    </>
                  ) : connector?.provider === 'arcanum_ai' ? (
                    <>
                      <h5>Configuration options for this flow.</h5>
                      <br />
                      Choose your focus area:
                      <br />
                      <select
                        id="toneOfVoice"
                        defaultValue={selectedFocusArea}
                        onChange={handleFocusAreaChange}
                        className="form-select mb-3"
                      >
                        {financialReportFocusArea.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                      <Button
                        variant="primary"
                        type="submit"
                        onClick={test_configuration}
                        className="mt-3 px-4"
                        disabled={!wf_configSet || !selectedFile || configChanged}
                      >
                        Test Configuration
                      </Button>
                      &nbsp;
                      <Button
                        variant="primary"
                        type="submit"
                        onClick={run_workflow_check}
                        className="mt-3 px-4"
                        disabled={!selectedFile || !wf_configSet || configChanged}
                      >
                        Run Workflow
                      </Button>
                      <Alert className="mt-3" key={configAlertType} variant={configAlertType}>
                        {configAlertContent}
                      </Alert>
                    </>
                  ) : connector?.provider === 'manual_email' ? (
                    <>
                      <h3>Email Output</h3>
                      <p>Once the Arcanum process has completed we will send the result to your email inbox.</p>
                      <StatusMessages
                        resetStatuses={resetStatuses}
                        lookupTableData={lookupTableData}
                        stopJobStatusPoll={stopJobStatusPoll}
                        WJST_id={WJST_id}
                        workato_recipe_id={workato_recipe_id}
                        refreshTheRecipe={refreshTheRecipe}
                      />
                    </>
                  ) : null}
                </>
              )}
            </>
          </Col>
        ) : null;
      })}
    </>
  );
};

export { FinancialReportWorkFlow };
